import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import LoadingSpinner from './components/LoadingSpinner';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/site.css';
import { MsalProvider } from '@azure/msal-react';
import AppRouter from './router/BaseRouter';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
export const UserContext = React.createContext();
Modal.setAppElement('#root')
function App({ instance }) {
	return (
		<MsalProvider instance={instance}>
		<div className="full-wrap">
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<LoadingSpinner />
					<Router>
						<AppRouter />
					</Router>
				</PersistGate>
			</Provider>
			</div>
		</MsalProvider>
	);
}
App.propTypes = {
	instance: PropTypes.any
};
export default App;
